<template>
  <div class="d-flex align-start pa-3">
    <div class="section_inner">
      <ArticleBreadcrumbsLegacy :items="seodata.breadcrumbs" class="pr-0" />

      <v-layout column>
        <v-flex>
          <v-layout
            wrap
            :class="[
              isHotJob ? 'justify-center mt-2 ' : 'justify-space-between',
            ]"
          >
            <v-flex
              xl10
              lg10
              class="jobs-row"
              text-center
              v-show="isHotJob && !IsClassifiedJob"
            >
              <a
                :href="`https://www.drushim.co.il/${jobData.Company.ToUrl}`"
                class="no-underline-all"
              >
                <v-img
                  contain
                  :src="jobData.Company.HotJobBannerLink"
                  class="pointer"
                  max-height="80"
                />
              </a>
            </v-flex>

            <v-flex xl10 lg10 class="jobs-row">
              <JobItem
                :job-details="jobData"
                class="job-item"
                :isSingleJob="true"
                :class="[isHotJob ? 'mt-7 ' : '']"
                :ssasource="ssaSource"
                :currentPage="'recommender_Single Job'"
                :recomended-job="isRecomendedJobByCookie"
                :is-hitech="isHitech"
              />
              <SmartAgentStrip>
                קבל התראות לסוכן החכם עבור קטגוריה זו
              </SmartAgentStrip>

              <v-row justify="center" class="mt-2">
                <v-col cols="12">
                  <Recommender
                    :currentPage="'recommender_Single Job'"
                    :maxJobs="6"
                    :forwardToJobPage="false"
                    :displayType="1"
                    :displayJobDescription="true"
                  />
                  <!-- spacer for Odd num of jobs -->

                  <v-spacer></v-spacer>
                </v-col>

                <v-col cols="12" class="text-center">
                  <v-btn
                    rounded
                    color="primary"
                    outlined
                    nuxt
                    @click.native="ShowMoreJobs()"
                    :to="`/jobs/cat${jobData.JobContent.Categories[0].Code}`"
                  >
                    למשרות נוספות
                  </v-btn>
                </v-col>
              </v-row>
            </v-flex>

            <v-flex class="ads-row" v-show="!isHotJob">
              <v-layout colomun wrap v-if="mountedPage">
                <v-flex>
                  <SectionCompaniesInnerPages
                    :is-hitech="isHitech"
                    :page="'singleJobPage'"
                  />
                </v-flex>
              </v-layout>
            </v-flex>
          </v-layout>
        </v-flex>
      </v-layout>
    </div>
    <CvConfirmation />
  </div>
</template>

<script>
import drushim_lodash from 'lodash';
import gtm from '@/lib/gtm';
import JobItem from '@/components/Jobs_List/Jobs_On_Drushim/Job_Item/JobItem';
import SectionCompaniesInnerPages from '@/components/Jobs_List/SectionCompaniesInnerPages';

import SmartAgentStrip from '@/components/Single_Jop_Page/Smart_Agent_Strip/SmartAgentStrip';
import SeoOptimization from '@/components/mixins/SeoOptimization';
import CvConfirmation from '@/components/Dialogs/CvConfirmation/CvConfirmation';
import Recommender from '@/components/Recommender/Recommender';
import { JOB } from '@/lib/api.js';

import { isEmpty } from 'lodash';

export default {
  name: 'jobPage',
  mixins: [SeoOptimization],
  layout: 'innerPage',
  components: {
    JobItem,
    SectionCompaniesInnerPages,
    SmartAgentStrip,
    CvConfirmation,
    Recommender,
  },

  data() {
    return {
      mainCategory: '',
      error: false,
      mountedPage: false,
    };
  },
  destroyed() {
    // googletag.destroySlots();
  },

  computed: {
    ssa() {
      return drushim_lodash.get(this.$ssa, 'vm', {});
    },

    ssaSource() {
      return drushim_lodash.has(this.$route.query, 'ref') ? 4 : 0;
    },
  },

  async asyncData({ route, $axios, redirect, $cookies }) {
    const { code } = route.params;
    const { hash } = route.params;
    const { query } = route;
    const { ref, sag, tid } = query;

    let isRecomendedJobByCookie = $cookies.get('drushim-jID-' + code)
      ? true
      : false;

    let params = {
      jobcode: code,
      jobhash: hash,
    };
    Object.assign(params, query);
    params.ssasource = ref === '34' ? 4 : 0;

    try {
      let { data } = await $axios.get(`${JOB}`, {
        params,
      });

      if (data.IsError) {
        throw data.Errors;
      }

      if (data.IsRedirect) {
        let redirectUrl = data.RedirectTo ? data.RedirectTo : '/';
        redirect(307, redirectUrl);
        return;
      }

      return {
        isRecomendedJobByCookie,
        error: data.IsError,
        ssaData: data.SSAEvents,
        jobData: data.Job,
        isHotJob: data.Job.JobInfo?.Hot,
        IsClassifiedJob: data.Job.JobInfo?.IsClassifiedJob,
        isHitech: data.IsHitech,

        G4JobScript: data.Job.JobInfo?.G4JobScript,
        seodata: {
          metaData: data.SEO.MetaDataItems,
          pageTitle: data.SEO.title,
          breadcrumbs: data.SEO.BreadCrumbs.Keys,
          canonicalUrl: data.SEO.CanonicalUrl,
        },
        sag: sag,
        tid: tid,
      };
    } catch (e) {
      console.log('single job page error', e);
      redirect(307, '/');
      return;
    }
  },
  head() {
    return {
      link: [{ rel: 'canonical', href: this.seodata.canonicalUrl }],
      title: this.seodata.pageTitle,
      meta: this.seodata.metaData,
      // disable sanitizers so the script
      __dangerouslyDisableSanitizers: ['script'],
      script: [
        {
          innerHTML: this.G4JobScript,
          type: 'application/ld+json',
        },
      ],
    };
  },
  mounted() {
    this.mountedPage = true;
    if (!this.error) {
      isEmpty(this.ssaData) ? null : this.sendSSA(this.ssaData);
      console.log('sending ssaData');
      // this.sendSSA(this.ssaData);
      /**
       * gtm data layers
       */
      const singleJobPage = {
        event: 'drushim_ee',
        ecommerce: {
          detail: {
            products: [
              drushim_lodash.pick(this.jobData.JobAnalytics, [
                'name',
                'id',
                'price',
                'brand',
                'category',
                'variant',
                'quantity',
                'position',
                'dimension20',
                'dimension21',
                'dimension15',
                'dimension19',
                'dimension22',
                'dimension16',
                'ppcd',
                'ppcm',
                'metric1',
              ]),
            ],
          },
        },
      };

      // open_window
      const openWindow = {
        jobid: this.jobData.Code,
        event: 'open_window',
      };

      gtm(openWindow);
      gtm(singleJobPage);
    } else {
      this.$router.push('/404');
    }
  },

  methods: {
    ShowMoreJobs() {
      const dataLayer = {
        category: 'הקלקה על משרות נוספות',
        event: 'drushim',
      };
      // gtm(_dataLayer);
      gtm(dataLayer);
    },
    sendSSA(evenData) {
      if (this.ssa?.logResponse) {
        this.ssa.logResponse('LogSSA', evenData);
        console.log('LogSSA Defined');
      } else {
        console.log('LogSSA undefined');
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.theme--light.v-list {
  background: transparent;
}

.jobs-row {
  max-width: 934px;
}

.ads-row {
  max-width: 300px;
}

.job-item {
  border-right: 9px solid #f2f0ef;
}

.job-item.preferred {
  border-right: 9px solid $primary;
}

.filter-btn {
  margin: 0;
  margin-left: 14px;
  border: solid 1px #e3e4e6;
  background-color: rgba(46, 40, 36, 0);
  display: inline-flex;
  align-items: center;
  padding: 5px 10px 5px 10px;
  letter-spacing: -1px;
  font-size: 12px;
}

.filter-by-text {
  display: none;
}

.filter-icon {
  display: inline-block;
  margin-left: 6px !important;
}

.filter-icon:before {
  color: #000;
}

.filter-btn:hover {
  border: 1px solid #000;
}

h3 {
  font-weight: normal;
  font-style: normal;
  font-stretch: normal;
  line-height: 1;
  letter-spacing: -0.9px;
}

.aside-ad {
  background: #3e4a54;
  text-align: center;
}

@media only screen and (min-width: 700px) {
  .filter-by-text {
    display: block;
  }

  .filter-btn {
    margin: 0;
    height: 50px;
    width: 200px;
    margin-left: 14px;
    border: solid 1px #e3e4e6;
    background-color: rgba(46, 40, 36, 0);
    display: inline-flex;
    align-items: center;
    padding: 5px 10px 5px 10px;
    letter-spacing: -1px;
    font-size: 24px;
  }
}

@media screen and (max-width: 1280px) {
  .jobs-row {
    max-width: 100%;
  }

  .ads-row {
    display: none;
  }
}
</style>
